import { FirstPage, NavigateBefore, NavigateNext, LastPage } from '@mui/icons-material';
import { PaginationItemProps, Button } from '@mui/material';
import './style.css';

function PaginationButton({ type, disabled, selected, children, onClick }: PaginationItemProps){
  const className = type;
  let buttonLabel = children;

  switch(type){
    case 'first':
      buttonLabel = <FirstPage/>
      break;
    case 'previous':
      buttonLabel = <NavigateBefore/>
      break;
    case 'next':
      buttonLabel = <NavigateNext/>
      break;
    case 'last':
      buttonLabel = <LastPage/>
      break;
    default:
      break;
  };

  const handleButtonClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if(onClick && !disabled){
      onClick(e);
    };
  };

  return(
    <div onClick={handleButtonClick}>
      <Button
        className={className}
        variant='contained'
        disableElevation
        disabled={disabled}
        sx={{
          backgroundColor: selected ? '#ff3d03' : '#6c7373 !important',
          color: '#fff',
          fontFamily: "'Open Sans', sans-serif",
          fontSize: '14px',
          fontWeight: 700,
          lineHeight: '14.64px',
          cursor: selected ? 'default' : 'pointer',
          transition: 'background-color 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: selected ? '#ff3d03' : '#a9a9a9 !important',
          },
        }}
      >
        {buttonLabel}
      </Button>
    </div>
  )
} export default PaginationButton;